import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
const HINT_STORAGE_KEY = 'jbPdpGalleryRevampSpinZoomHintSeen';
const HINT_DURATION = 4000;

// One-time spin/zoom hint over the 360 viewer, remembered per device
const PDPGalleryRevampSpinZoomHint = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  const isTouchDevice = useIsTouchDevice();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      try {
        if (window.localStorage.getItem(HINT_STORAGE_KEY)) {
          return;
        }
      } catch {}
      setIsVisible(true);
      const dismiss = () => {
        setIsVisible(false);
        try {
          window.localStorage.setItem(HINT_STORAGE_KEY, "1");
        } catch {}
      };
      const timeout = setTimeout(dismiss, HINT_DURATION);
      window.addEventListener("pointerdown", dismiss, {
        once: true
      });
      return () => {
        clearTimeout(timeout);
        window.removeEventListener("pointerdown", dismiss);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = isVisible ? "opacity-100" : "opacity-0";
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = classnames("absolute inset-x-0 bottom-4 z-[2] flex justify-center pointer-events-none", "transition-opacity duration-500 ease-out", t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !isVisible;
  const t6 = isTouchDevice ? "Drag to spin \xB7 Pinch to zoom" : "Drag to spin \xB7 Use + and \u2212 to zoom";
  let t7;
  if ($[5] !== t6) {
    t7 = <span className="rounded-full bg-gray-dark/80 px-4 py-2 text-sm text-white">{t6}</span>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t7) {
    t8 = <div className={t4} aria-hidden={t5}>{t7}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
PDPGalleryRevampSpinZoomHint.propTypes = {
  className: PropTypes.string
};
export default PDPGalleryRevampSpinZoomHint;